import appApi from '../../../../../../api/app-api';
import globalSettingsStores from '../../../../../../stores/settings-stores';
import { toast } from 'react-toastify';
import { displayErrorText } from '../../../../../../api/errors/api-error-codes';

export const deleteExamOperation = async (
  examId: number,
  setExamId: (examId: number | null) => any,
) => {
  try {
    setExamId(examId);

    const res = await appApi.deleteExamTypeId(examId);

    if (res.data.ok) {
      await globalSettingsStores.fetchSetting();
    } else if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
    }

    setExamId(null);
  } catch (e) {
    setExamId(null);
  }
};
